import { styled } from '@ori-ui/mui';
export var Root = styled('p')(function (_ref) {
  var theme = _ref.theme;
  return {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightBold,
    margin: 0
  };
});
//# sourceMappingURL=styles.js.map